import React, { useState, useEffect, useRef } from "react";
import Header from "../Section/Header";
import { Search, Clock } from "lucide-react";
import Footer from "../Section/Footer";
import FinalPayment from "./FinalPayment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import SearchListData from "../Section/SearchListData";
import {
  create_Matchmaking,
  server_post_data,
  delete_for_android,
  view_subjecsts,
  match,
} from "../../ServiceConnection/serviceconnection";
import { CustomAlert } from "../../CommonJquery/CustomAlert";
export default function MarriageRelationship({ page_name }) {
  const timeInputRefBoy = useRef(null);
  const timeInputRefGirl = useRef(null);
  const placeInputRefBoy = useRef(null);
  const placeInputRefGirl = useRef(null);
  const [FinalDataPass, setFinalDataPass] = useState(null);
  const [data_pass_astrologer, setdata_pass_astrologer] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
      const [showModal , setshowModal] = useState(false);
  const [boyData, setBoyData] = useState({
    name: "",
    gender: "male",
    dob: null,
    time: "",
    place: "",
    latitude: "",
    longitude: "",
  });
  const [girlData, setGirlData] = useState({
    name: "",
    gender: "female",
    dob: null,
    time: "",
    place: "",
    latitude: "",
    longitude: "",
  });
  const [errors, setErrors] = useState({ boy: {}, girl: {} });
  const [ShowStep2, setShowStep2] = useState(false);
  
    const [topicList, setTopicList] = useState([]);
    const [SavedRecentData, setSavedRecentData] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [filteredTopicList, setFilteredTopicList] = useState(topicList);
    //:------------------------All Kundali Data------------------------------
  const [editingGender, setEditingGender] = useState(""); 
    const [topicList2, setTopicList2] = useState([]);
    const [filteredTopicList2, setFilteredTopicList2] = useState(topicList2);
useEffect(() => {
  if (!searchText.trim()) {
    setFilteredTopicList(topicList);
    setFilteredTopicList2(topicList2);
    return;
  }

  const regex = new RegExp(searchText, "i");

  // Full search for topicList
  const filteredList = topicList.filter(
    (item) =>
      (item.male_name && regex.test(item.male_name)) ||
      (item.female_name && regex.test(item.female_name)) ||
      (item.female_city_name && regex.test(item.female_city_name)) ||
      (item.male_city_name && regex.test(item.male_city_name))
  );

  // Only user_name search for topicList2
  const filteredList2 = topicList2
    .filter(
      (item) =>
        item.user_name &&
        item.user_name.toLowerCase().includes(searchText.toLowerCase())
    )
    .sort((a, b) => (a.user_name || "").localeCompare(b.user_name || ""));

  setFilteredTopicList(filteredList);
  setFilteredTopicList2(filteredList2);
}, [searchText, topicList, topicList2]);
  const splitPlace = (placeString) => {
    if (!placeString) return { city: "", state: "", country: "" };

    const parts = placeString.split(",").map((part) => part.trim());

    return {
      city: parts[0] || "",
      state: parts[1] || "",
      country: parts[2] || "",
    };
  };

  const [message, setMessage] = useState("");

  const validate = () => {
    const boyErrors = {};
    const girlErrors = {};
    let messageError = "";

    if (!boyData.name.trim()) boyErrors.name = "Enter boy's name.";
    if (!boyData.dob) boyErrors.dob = "Enter boy's birth date.";
    if (!boyData.time) boyErrors.time = "Enter boy's birth time.";
    if (!boyData.place.trim()) boyErrors.place = "Enter boy's birth place.";

    if (!girlData.name.trim()) girlErrors.name = "Enter girl's name.";
    if (!girlData.dob) girlErrors.dob = "Enter girl's birth date.";
    if (!girlData.time) girlErrors.time = "Enter girl's birth time.";
    if (!girlData.place.trim()) girlErrors.place = "Enter girl's birth place.";

    if (!message.trim()) {
      messageError = "Please fill the message.";
    } else if (message.trim().length < 50) {
      messageError = "Please enter at least 50 characters.";
    }

    // 👇 Add this line to actually store the message error
    const combinedErrors = { boy: boyErrors, girl: girlErrors };
    if (messageError) {
      combinedErrors.message = messageError;
    }

    setErrors(combinedErrors);
    return (
      Object.keys(boyErrors).length === 0 &&
      Object.keys(girlErrors).length === 0 &&
      !messageError
    );
  };

  const maxChars = 1000;
  const handleChange = (e) => {
    const value = e.target.value;
    if (value.length <= maxChars) {
      setMessage(value);
      if (errors.message) {
        setErrors((prev) => ({ ...prev, message: "" }));
      }
    }
  };

  const isMaxReached = message.length === maxChars;
  const clearFieldError = (type, field) => {
    setErrors((prev) => ({
      ...prev,
      [type.toLowerCase()]: {
        ...prev[type.toLowerCase()],
        [field]: "",
      },
    }));
  };

  const handleNextStep = (e) => {
    e.preventDefault();
    if (validate()) {
      const { city, state, country } = splitPlace(boyData.place);
      const girlPlace = splitPlace(girlData.place);
      //------Boy Data
      const dobDate = new Date(boyData.dob);
      const dobYear = dobDate.getFullYear();
      const dobMonth = String(dobDate.getMonth() + 1).padStart(2, "0");
      const dobDay = String(dobDate.getDate()).padStart(2, "0");
      //------Girl Data
      const dobDate2 = new Date(girlData.dob);
      const dobYear2 = dobDate.getFullYear();
      const dobMonth2 = String(dobDate2.getMonth() + 1).padStart(2, "0");
      const dobDay2 = String(dobDate2.getDate()).padStart(2, "0");
      const fd = new FormData();
      fd.append("male_name", boyData.name);
      fd.append("male_dob", `${dobYear}-${dobMonth}-${dobDay}`);
      fd.append("male_dobtime", boyData.time);
      fd.append("male_city_name", city);
      fd.append("male_state_name", state);
      fd.append("male_country_name", country);
      fd.append("male_latitude_data", boyData.latitude);
      fd.append("male_longitude_data", boyData.longitude);
      fd.append("user_gender", "Male");
      fd.append("question_1", message);
      fd.append("female_name", girlData.name);
      fd.append("female_dob", `${dobYear2}-${dobMonth2}-${dobDay2}`);
      fd.append("female_dobtime", girlData.time);
      fd.append("female_city_name", girlPlace.city);
      fd.append("female_state_name", girlPlace.state);
      fd.append("female_country_name", girlPlace.country);
      fd.append("female_latitude_data", girlData.latitude);
      fd.append("female_longitude_data", girlData.longitude);
      if (data_pass_astrologer !== null) {
        fd.append("astrology_id", data_pass_astrologer.astrology_id);
        fd.append("astrology_name", data_pass_astrologer.astro_name);
      } else {
        fd.append("astrology_id", "0");
        fd.append("astrology_name", "");
      }
      fd.append("cat_id", "0");
      fd.append("thread_id", "0");
      fd.append("category_name", page_name);
      setFinalDataPass(fd);

      setShowStep2(true);
    }
  };

  const openTimePicker = (type) => {
    if (type === "Boy" && timeInputRefBoy.current) {
      timeInputRefBoy.current.showPicker();
    } else if (type === "Girl" && timeInputRefGirl.current) {
      timeInputRefGirl.current.showPicker();
    }
  };

  useEffect(() => {
    if (!window.google || !window.google.maps || !window.google.maps.places) {
      console.warn("Google Maps JS not loaded");
      return;
    }

    const setupAutocomplete = (ref, setDataFn, label) => {
      if (!ref.current) {
        console.warn(`${label} ref not ready`);
        return null;
      }

      const autocomplete = new window.google.maps.places.Autocomplete(
        ref.current,
        {
          types: ["(cities)"],
          componentRestrictions: { country: "in" },
        }
      );

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        const formatted = place.formatted_address || place.name || "";

        const lat = place.geometry?.location?.lat();
        const lng = place.geometry?.location?.lng();

        if (lat !== undefined && lng !== undefined) {
          setDataFn((prev) => ({
            ...prev,
            place: formatted,
            latitude: lat.toFixed(6),
            longitude: lng.toFixed(6),
          }));
        } else {
          console.warn(`Location data missing for ${label}`);
        }
      });

      return autocomplete;
    };

    const autoBoy = setupAutocomplete(placeInputRefBoy, setBoyData, "Boy");
    const autoGirl = setupAutocomplete(placeInputRefGirl, setGirlData, "Girl");

    return () => {
      if (autoBoy) window.google.maps.event.clearInstanceListeners(autoBoy);
      if (autoGirl) window.google.maps.event.clearInstanceListeners(autoGirl);
    };
  }, []);

   useEffect(() => {
      masterDataGet();
        masterDataGet_Kuldi_data();
    }, []);
    const masterDataGet = async () => {
      setIsLoading(true);
      const fd = new FormData();
      fd.append("flag", 8);
      fd.append("sub_id", 0);
      fd.append("cat_id", 0);
      fd.append("thread_id", 0);
  
      await server_post_data(view_subjecsts, fd)
        .then(async (Response) => {
          setIsLoading(false);
          let data = Response.split("~@~");
          if (parseInt(data[0]) === 1) {
            CustomAlert("Error", data[1]);
          } else {
            setTopicList(JSON.parse(JSON.parse(data[1])[0]["get_data_subs"]));
            setSavedRecentData(
              JSON.parse(JSON.parse(data[1])[0]["get_data_subs"])[0]
            );
          }
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    };


  const masterDataGet_Kuldi_data = async () => {
    setIsLoading(true);
    const fd = new FormData();
    fd.append("flag", 7);
    fd.append("sub_id", 0);
    fd.append("cat_id", 0);
    fd.append("thread_id", 0);

    await server_post_data(view_subjecsts, fd)
      .then(async (Response) => {
        setIsLoading(false);
        let data = Response.split("~@~");
        if (parseInt(data[0]) === 1) {
          CustomAlert("Error", data[1]);
        } else {
          setTopicList2(JSON.parse(JSON.parse(data[1])[0]["get_data_subs"]));
          setSavedRecentData(
            JSON.parse(JSON.parse(data[1])[0]["get_data_subs"])[0]
          );
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

const handleShowSaveSearchModl = (gender) => {
  console.log("Modal opened for:", gender);
  setEditingGender(gender);
  setshowModal(true);
  masterDataGet_Kuldi_data();
};




  const formatTimeForInput = (timeString) => {
  if (!timeString) return "";

  // If it's already in HH:MM format, return as is
  if (/^\d{2}:\d{2}$/.test(timeString)) {
    return timeString;
  }

  // If it's in HH:MM:SS format, remove seconds
  if (/^\d{2}:\d{2}:\d{2}$/.test(timeString)) {
    return timeString.substring(0, 5);
  }

  // If it's in 12-hour format (like "02:30 PM"), convert to 24-hour
  if (timeString.includes("AM") || timeString.includes("PM")) {
    const [time, period] = timeString.split(" ");
    const [hours, minutes] = time.split(":");
    let hour24 = parseInt(hours);

    if (period === "PM" && hour24 !== 12) {
      hour24 += 12;
    } else if (period === "AM" && hour24 === 12) {
      hour24 = 0;
    }

    return `${hour24.toString().padStart(2, "0")}:${minutes}`;
  }

  return timeString;
};
const handleEditKundali = (kundali) => {
  console.log("✏️ Editing Kundali:", kundali);

  // Ensure DOB is converted to dayjs
  const dobParts = kundali.user_dob.split("-");
  const dobDate = dayjs(new Date(dobParts[0], dobParts[1] - 1, dobParts[2]));

  const placeString = `${kundali.city_name}, ${kundali.state_name}, ${kundali.country_name}`;
  const formattedTime = formatTimeForInput(kundali.user_dobtime2);

  const formObj = {
    name: kundali.user_name || "",
    gender: kundali.user_gender || "",
    dob: dobDate, // ✅ This must be dayjs()
    time: formattedTime,
    place: placeString,
    language: "english",
    saveKundali: true,
    latitude: kundali.latitude_data || "",
    longitude: kundali.longitude_data || "",
  };

  if (editingGender === "male") {
    setBoyData(formObj);
  } else if (editingGender === "female") {
    setGirlData(formObj);
  }

  setshowModal(false);
};

  const handleClose = () => {
    setshowModal(false);
  };
  return (
    <>
      <Header />
      <div className="bg-gradient-to-br from-slate-900 via-purple-900 to-indigo-900 bg-[length:300%_300%] animate-gradient-flow py-10 px-4">
        <div className="max-w-[1050px] mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400">
              💍 Marriage & Relationship Consultation
            </h2>
            <p className="text-lg text-purple-300 mt-2">
              Get expert astrological advice to navigate your love life and
              relationships.
            </p>
          </div>

          <div className="rounded-lg text-card-foreground shadow-sm bg-slate-800/50 backdrop-blur-sm px-3 py-4">
            {!ShowStep2 && (
              <form
                id="kundali-form"
                onSubmit={handleNextStep}
                className="grid grid-cols-1 md:grid-cols-2 gap-6 relative"
              >
                {[
                  {
                    title: "Boy",
                    data: boyData,
                    setData: setBoyData,
                    ref: timeInputRefBoy,
                    err: errors.boy,
                  },
                  {
                    title: "Girl",
                    data: girlData,
                    setData: setGirlData,
                    ref: timeInputRefGirl,
                    err: errors.girl,
                  },
                ].map(({ title, data, setData, ref, err }, idx) => (
                  <div key={title} className="space-y-4 px-2 relative">
                    <h3 className="text-xl text-purple-100 font-semibold text-center">
                      {title}'s Details
                    </h3>

                    <div>
                      <label className="text-purple-200 text-sm">
                        Full Name
                      </label>
                      <div className="flex items-center justify-between h-11 w-full rounded-md px-3 py-3 bg-slate-700/50 text-[var(--light-purple)] placeholder-[var(--light-purple)] border">
                        <input
                          type="text"
                          id="name"
                          placeholder="Enter your full name"
                          className="custum_input"
                          style={{
                            borderColor: "var(--primary-border)",
                            borderWidth: "1.5px",
                          }}
                          value={data.name}
                          onChange={(e) => {
                            setData({ ...data, name: e.target.value });
                            clearFieldError(title, "name");
                          }}
                        />
                        <button
                          type="button"
                          aria-label="Search"
                            onClick={() => handleShowSaveSearchModl(title === "Boy" ? "male" : "female")}
                        >
                          <Search
                            color="#c0a0e7"
                            className="mr-[-6px]"
                            size={20}
                          />
                        </button>
                      </div>

                      {err.name && (
                        <span className="text-red-400 text-sm">{err.name}</span>
                      )}
                    </div>

                    {/* Date of Birth */}
                    <div className="space-y-1 cusm_date_picker_container">
                      <label
                        htmlFor="dob"
                        className="text-sm font-medium text-purple-200"
                      >
                        Date of Birth <span className="text-red-400">*</span>
                      </label>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          format="DD/MM/YYYY"
                          value={data.dob}
                          onChange={(date) => {
                            setData({ ...data, dob: date });
                            clearFieldError(title, "dob");
                          }}
                       
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              placeholder: "Select your birth date",
                              variant: "outlined",
                              className: "custom-datepicker",
                            },
                          }}
                        />
                      </LocalizationProvider>

                      {err.dob && (
                        <span className="text-red-400 text-sm error_SPAN">
                          {err.dob}
                        </span>
                      )}
                    </div>

                    <div
                      className="space-y-1 timeofBirth"
                      onClick={() => openTimePicker(title)}
                    >
                      <label className="text-sm font-medium text-purple-200">
                        Time of Birth *
                      </label>
                      <div className="relative">
                        <input
                          type="time"
                          ref={ref}
                          className="appearance-none h-11 w-full rounded-md px-4 py-2 pr-10 bg-slate-700/50 text-[var(--light-purple)] border"
                          style={{
                            borderColor: "var(--primary-border)",
                            borderWidth: "1.5px",
                          }}
                          value={data.time}
                          onChange={(e) => {
                            setData({ ...data, time: e.target.value });
                            clearFieldError(title, "time");
                          }}
                        />
                        <Clock
                          size={18}
                          className="absolute right-3 top-1/2 -translate-y-1/2 text-purple-300 pointer-events-none"
                        />
                      </div>
                      {err.time && (
                        <span className="text-red-400 text-sm">{err.time}</span>
                      )}
                    </div>

                    <div>
                      <label className="text-purple-200 text-sm">
                        Place of Birth
                      </label>
                      <input
                        type="text"
                        value={data.place}
                        ref={
                          title === "Boy" ? placeInputRefBoy : placeInputRefGirl
                        }
                        onChange={(e) => {
                          setData({ ...data, place: e.target.value });
                          clearFieldError(title, "place");
                        }}
                        className="w-full bg-slate-700/50 px-3 py-2 rounded border border-purple-500/20 text-white"
                        placeholder="City, State, Country"
                      />
                      {err.place && (
                        <span className="text-red-400 text-sm">
                          {err.place}
                        </span>
                      )}
                    </div>

                    {data.latitude?.length > 0 &&
                      data.longitude?.length > 0 && (
                        <div className="flex items-center gap-4">
                          <div className="text-[12px] font-medium text-purple-200">
                            Latitude: {data.latitude}
                          </div>
                          <div className="text-[12px] font-medium text-purple-200">
                            Longitude: {data.longitude}
                          </div>
                        </div>
                      )}

                    {/* Divider after first column */}
                    {idx === 0 && (
                      <div className="hidden md:block absolute right-[-12px] top-[15px] bottom-[-16px] w-[1.5px] bg-white opacity-50" />
                    )}
                  </div>
                ))}

                {/* Message / Query */}
                <div className="mt-2 md:col-span-2">
                  <div className="flex justify-between items-center w-full">
                    <label
                      htmlFor="message"
                      className="text-sm font-medium text-purple-200 "
                    >
                      Ask Your Questions
                      <span className="text-red-400">*</span>
                    </label>
                    <span
                      className={`text-sm font-medium ${
                        isMaxReached ? "text-red-400" : "text-purple-200"
                      }`}
                    >
                      Characters: {message.length} / {maxChars}
                    </span>
                  </div>

                  <textarea
                    id="message"
                    rows="4"
                    placeholder="Write your query or message (min 50 characters)"
                    className="w-full rounded-md h-[140px] px-4 py-2 bg-slate-700/50 text-[var(--light-purple)] placeholder-[var(--light-purple)] border"
                    style={{
                      borderColor: "var(--primary-border)",
                      borderWidth: "1.5px",
                      resize: "none",
                    }}
                    value={message}
                    onChange={handleChange}
                    maxLength={maxChars}
                  />
                  {errors.message && (
                    <span className="text-sm text-red-400">
                      {errors.message}
                    </span>
                  )}
                </div>
                <div className="md:col-span-2">
                  <button
                    type="submit"
                    className="mt-4 w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white py-[13px] text-[15px] rounded-full font-semibold"
                  >
                    Next
                  </button>
                </div>
              </form>
            )}
            {ShowStep2 && (
              <FinalPayment
                FinalDataPass={FinalDataPass}
                Page_Name={page_name}
              />
            )}
          </div>
        </div>
      </div>
      <SearchListData
        showModal={showModal}
        handleClose={handleClose}
        searchText={searchText}
        setSearchText={setSearchText}
            filteredTopicList={filteredTopicList2}
        handleEditKundali={handleEditKundali}
      />
      <Footer />
    </>
  );
}
